import BuzzfeedFull from 'marketing-website/components/icons/BuzzfeedFull';
import heroImage from 'marketing-website/media/images/pages/case-studies/buzzfeed/cover@2x.jpg';
import statsImage from 'marketing-website/media/images/pages/case-studies/buzzfeed/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/buzzfeed/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/buzzfeed/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/buzzfeed/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/buzzfeed/image-02-b@2x.jpg';
import image03 from 'marketing-website/media/images/pages/case-studies/buzzfeed/image-03@2x.jpg';
import quote from 'marketing-website/media/images/pages/case-studies/buzzfeed/quote@2x.jpg';

const buzzfeedAssets = {
  heroImage: {
    src: heroImage,
    srcSet: heroImage,
    maxWidth: 504,
    alt: '',
  },
  heroLogo: BuzzfeedFull,
  statsImage: {
    src: statsImage,
    srcSet: statsImage,
    maxWidth: 1290,
    alt: '',
  },
  stats: [
    {
      id: 0,
      stat: '700',
      title: 'Projects',
      copy:
        'Marvel supports their global business scale of work and high project activity',
    },
    {
      id: 1,
      stat: '6000',
      title: 'Designs',
      copy:
        'Marvel high number of designs uploaded by their 20 strong design team ',
    },
    {
      id: 2,
      stat: '55',
      title: 'Users',
      copy:
        'Designers use Marvel to share work with content and other teams across the company ',
    },
  ],
  singleImages: {
    first: {
      src: image03,
      maxWidth: 1141,
      alt: '',
    },
  },
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 550,
        alt: '',
      },
      {
        src: image01b,
        maxWidth: 494,
        alt: '',
      },
    ],
    second: [
      {
        src: quote,
        maxWidth: 556,
        alt: '',
      },
      {
        maxWidth: 490,
        copy:
          '"Marvel is a tool in our designers’ toolkit for them to share their work and what stage it’s in with the rest of the team"',
      },
    ],
    third: [
      {
        src: image02a,
        maxWidth: 556,
        alt: '',
      },
      {
        src: image02b,
        maxWidth: 556,
        alt: '',
      },
    ],
  },
};

export default buzzfeedAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/buzzfeed.js